import { useState } from "react";
import { toast } from "sonner";
import { useClerk } from "@clerk/react";
import { Building2, Clock } from "lucide-react";
import { useApi, errMsg } from "../lib/api";
import { useMember } from "../lib/member";
import { Button } from "../components/ui/button";

export default function Onboarding() {
  const api = useApi();
  const { me, reload } = useMember();
  const { signOut } = useClerk();
  const [name, setName] = useState("");

  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/companies", { name }); toast.success("Company created"); reload(); }
    catch (er) { toast.error(errMsg(er)); }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 c-grid-bg">
      <div className="c-surface p-8 max-w-md w-full c-rise" data-testid="onboarding-card">
        <div className="h-10 w-10 rounded-lg bg-[#00E599] text-[#0B1017] grid place-items-center font-display font-extrabold mb-6">369</div>
        {me?.is_owner ? (
          <form onSubmit={create} className="grid gap-4">
            <div><div className="c-eyebrow mb-2">Get started</div><h1 className="text-3xl font-extrabold">Create your company</h1>
              <p className="text-sm text-slate-400 mt-2">You'll be its company admin and can invite staff and vendors.</p></div>
            <label className="grid gap-1.5"><span className="text-xs text-slate-400">Company name</span>
              <input className="c-input" required minLength={2} value={name} onChange={(e) => setName(e.target.value)} data-testid="company-name-input" placeholder="Aatmiya Real Estate" /></label>
            <Button type="submit" data-testid="create-company-btn" className="bg-[#00E599] text-[#0B1017] hover:bg-[#00C482] font-semibold"><Building2 size={15} className="mr-2" />Create company</Button>
          </form>
        ) : (
          <div className="grid gap-3" data-testid="awaiting-invite">
            <Clock className="text-amber-400" />
            <h1 className="text-2xl font-extrabold">Waiting for an invite</h1>
            <p className="text-sm text-slate-400">Your account <span className="font-mono text-slate-200">{me?.email}</span> isn't part of a company yet. Ask your company admin to invite this email from Settings → Users, then refresh this page.</p>
            <div className="flex gap-2 mt-2">
              <Button onClick={reload} data-testid="refresh-invite-btn" className="bg-[#00E599] text-[#0B1017] hover:bg-[#00C482]">Refresh</Button>
              <Button variant="outline" onClick={() => signOut()} data-testid="onboarding-sign-out" className="border-[#1F2A3E] hover:bg-[#1A2234] hover:text-white">Sign out</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
